import { DateTime } from 'luxon'

///////////////////////////////////
// User
///////////////////////////////////

export type ConfigurationData = {
  isMaintenanceMode: boolean
  maintenanceMode?: {
    startAt: string
    endAt: string
    message: string
  }
}

export default class Configuration {
  isMaintenanceMode: boolean = false

  maintenanceMode?: {
    startAt: DateTime
    endAt: DateTime
    message: string
  }

  // Constructor --------------------------------------------------------------

  constructor(params?: ConfigurationData) {
    if (!params) return

    Object.assign(this, params)

    if (params.maintenanceMode)
      this.maintenanceMode = {
        ...params.maintenanceMode,
        startAt: DateTime.fromISO(params.maintenanceMode.startAt),
        endAt: DateTime.fromISO(params.maintenanceMode.endAt),
      }
  }
}
